import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { CreditModel } from "./credit-data-model";

export class CreditGridParams extends GridPostParams {}

export class CreditGridModel extends CreditModel { }

export class CreditListingModel extends GridModel<CreditGridModel> { }